import React, { Component } from 'react';
import { Link } from 'react-router-dom';


export default class Header extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // Default states
            menu_dropdown: false,
            login: false,
            redirectUrl: ""
        };

        this.toggleMenu = this.toggleMenu.bind(this);
        this.closeMenu = this.closeMenu.bind(this);
    }


    componentDidMount() {
        this.setState({
            login: this.props.login
        });
    }


    componentDidUpdate() {
        if (this.state.login != this.props.login) {
            this.setState({
                login: this.props.login
            });
        }
    }


    toggleMenu() {
        this.setState({
            menu_dropdown: !this.state.menu_dropdown
        });
    }


    closeMenu() {
        this.setState({
            menu_dropdown: false
        });
    }


    render() {
        const location = this.props.location;
        const redirectUrl = encodeURIComponent(location.pathname + location.search);
        return (
            <div className="header">
                <div className="header-wrapper">
                    <Link to="/" className="header__logo"></Link>

                    <div onClick={this.toggleMenu} className="header__menu">
                        <div className={"header__menu__bar header__menu__bar-1" + (this.state.menu_dropdown ? " header__menu__bar-1--active" : "")}></div>
                        <div className={"header__menu__bar header__menu__bar-2" + (this.state.menu_dropdown ? " header__menu__bar-2--active" : "")}></div>
                        <div className={"header__menu__bar header__menu__bar-3" + (this.state.menu_dropdown ? " header__menu__bar-3--active" : "")}></div>
                    </div>

                    {this.state.login !== true &&
                        <div className={"header__navbar" + (this.state.menu_dropdown ? " header__navbar--active" : "")}>
                            <div className="header__navbar__element">
                                <Link to="/trips?sort=rated" onClick={this.closeMenu} className="header__navbar__link">
                                    Trending trips
                                </Link>
                            </div>
                            <div className="header__navbar__element">
                                <Link to="/signup" onClick={this.closeMenu} className="header__navbar__link">
                                    Sign up
                                </Link>
                            </div>
                            <div className="header__navbar__element">
                                <Link to={`/login?redirect=${redirectUrl}`} onClick={this.closeMenu} className="button button-light">
                                    Login
                                </Link>
                            </div>
                        </div>
                    }

                    {this.state.login == true &&
                        <div className={"header__navbar" + (this.state.menu_dropdown ? " header__navbar--active" : "")}>
                            {/* <div className="header__navbar__element">
                                <Link to="/createtrip" onClick={this.closeMenu} className="header__navbar__link">
                                    Create Trip
                                </Link>
                            </div> */}
                            <div className="header__navbar__element">
                                <Link to="/account" onClick={this.closeMenu} className="header__navbar__link">
                                    Account
                                </Link>
                            </div>
                            <div onClick={this.props.setLogout} className={"header__navbar__element"} >
                                <div className="header__navbar__link">
                                    Logout
                                </div>
                            </div>
                        </div>
                    }

                </div>
            </div>
        )
    }
}
